export default {
    onboarding: {
        actions: {
            mainBlue: 'Start'
        }
    },
    details: {
        aboutProperty: 'Additional information',
        title: 'Please confirm the following information:',
        errorMsgInputTxt: 'Mandatory field',
        errorMsgGeneral: 'Please check the form before continuing',
        errorImages: 'Please add photos before continuing',
        address: {
            literal: 'Address',
            placeholder: 'Enter a location'
        },
        zipCode: {
            literal: 'Postcode'
        },
        propertyType: {
            literal: 'Property type',
            options: {
                appartment: 'Flat',
                maison: 'House',
                local_commercial: 'Business premises'
            }
        },
        residentType: {
            literal: 'Type of resident',
            options: {
                propietarie: 'Owner',
                locataire: 'Tenant',
                propietarie_non_occupant: 'Owner Non Occupant'
            }
        },
        moreThanTwoYears: {
            literal: 'Age of the building',
            options: {
                less: 'Less than 2 years',
                more: 'More than 2 years'
            }
        },
        observations: {
            literal: 'Comments'
        },
        map: {
            empty: {
                title: 'No address',
                text: 'Please enter a valid address'
            }
        },
        textArea: {
            placeHolder: 'Text length limited to 255 characters maximum'
        }
    },
    closing: {
        actions: {
            mobilierButton: 'Continue with furniture damage'
        }
    },
    compensationType: {
        title: 'Handling a claim has never been so easy',
        subtitle: 'About your property damage ',
        text: 'To do this, we offer three possible solutions:',
        recommended: 'Our recommendation!',
        amount: 'Amount reimbursed:',
        e2eCompensations: {
            gagDetail: {
                title: 'Do you want to do it yourself?',
                text: 'You are a handyman. We cover the cost of materials, small tooling costs and compensate you for the time spent.',
                link: 'Let’s estimate your needs together'
            },
            billma: {
                title: 'Compensation on quote',
                text: 'Attach photos and invoices of the damaged goods to your return. Our technical unit will validate it.',
                link: 'Load your quote'
            },
            renDetail: {
                title: 'Repair department',
                text: 'Use our repair service. Let us know when you are available for an appointment.',
                link: 'Make an appointment'
            }
        }
    },
    compensationMobilier: {
        title: 'Regarding your property damage',
        subtitle: 'Amount of compensation',
        total: 'Total:',
        totalAmount: 'Total compensation',
        actions: {
            primary: 'Yes, I accept the proposed compensation',
            secondary: 'I want to speak with an advisor'
        }
    }
}